<ng-template cellTemplate let-dataItem="dataItem">
    <div class="percentage" (click)="$event['ignoreClickOutside'] = true">{{dataItem | property: field |
        number:'1.1-1'}}<span *ngIf="(dataItem | property: field) != undefined">{{'wbo.common.percent' | translate}}</span>
    </div>
</ng-template>
<ng-template editTemplate let-dataItem="dataItem" let-columnIndex="columnIndex" let-column="column"
             let-formGroup="formGroup">
    <wbo-edit-grid-cell-activator [columnIndex]="columnIndex" [select]="true"
                                  [editControl]="editControl"></wbo-edit-grid-cell-activator>
    <fui-numeric-control #editControl (focussed$)="columnFocusHandler(columnIndex)" [decimals]="2" [attr.id]="elementId"
                         [formControl]="formGroup.get(column.field)" [control]="formGroup.get(column.field)"
                         [label]="'wbo.common.amount' | translate" [notation]="'wbo.common.percent' | translate"
                         [readOnly]="cellDisabled(formGroup, dataItem)"
                         [placeholder]="getPlaceholder(dataItem)">
    </fui-numeric-control>
</ng-template>
